import { getGroupFolderRulePermissionStore } from '../groupFolderRulePermissionStore';
import type { GroupFolderAndRulePermission } from '../schema/GroupFolderAndRulePermission';

export default function getGroupFolderAndRulePermission(
    groupId: string | null | undefined
): GroupFolderAndRulePermission | null | undefined {
    if (!groupId) {
        return null;
    }

    return getGroupFolderRulePermissionStore()?.folderRulePermissionTable.get(
        groupId.toLowerCase()
    );
}
